<template>
	<JonInfo>
		<template #message>
			<b>Keine Sorge</b>, wenn du noch keine oder wenig Erfahrung hast.<br/>
			Viele Arbeitgeber suchen auch Mitarbeiter, die in einen neuen Job hineinwachsen und dabei lernen
			wollen.<br />Dazu gibt es entsprechende <b>Einarbeitung und Einschulung</b>. &#128077;
		</template>
	</JonInfo>
</template>
<script>
import JonInfo from "@/vue/common/JonInfo.vue";

export default {
	components: {JonInfo}
}
</script>
